import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from "element-plus"
import "element-plus/dist/index.css"
// import * as Icons from '@element-plus/icons'
import * as Icons from '@element-plus/icons-vue';  
import '@/styles/index.scss' // global css
import NavTop from './components/NavTop.vue'
import NavBottom from './components/NavBottom.vue'
import { createPinia } from 'pinia'
import MainView from './components/MainView.vue';
import lang from 'element-plus/es/locale/lang/zh-cn';

const pinia = createPinia()
const app = createApp(App)

app.component('NavTop', NavTop);
app.component('NavBottom', NavBottom);
app.component('MainView', MainView);

for (let i in Icons) {  
  app.component(i, Icons[i]);  
}

// 禁止截屏
function disableScreenshot() {
  // 禁用截屏快捷键
  document.addEventListener('keydown', (e) => {
    // Android: Print Screen, iOS: 音量键组合等
    if (
      e.key === 'PrintScreen' ||
      (e.ctrlKey && e.key === 's') ||
      (e.metaKey && e.shiftKey && e.key === '3') || // Mac Command+Shift+3
      (e.metaKey && e.shiftKey && e.key === '4') // Mac Command+Shift+4
    ) {
      e.preventDefault()
      e.stopPropagation()
      return false
    }
  }, true)

  // 禁用右键菜单和长按截屏
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault()
    return false
  })

  // 禁用用户选择（防止某些截屏工具）
  document.body.style.webkitUserSelect = 'none'
  document.body.style.userSelect = 'none'
  document.body.style.webkitTouchCallout = 'none'

  // 监听截屏事件（某些设备支持）
  if (document.onscreenchange !== undefined) {
    document.addEventListener('screenchange', () => {
      console.warn('检测到截屏操作，已禁止')
    })
  }

  // 禁用volume key截屏（Android）
  document.addEventListener('volumedownchange', (e) => {
    e.preventDefault()
  })
  document.addEventListener('volumeupchange', (e) => {
    e.preventDefault()
  })
}

disableScreenshot()

// 注册 Service Worker (PWA支持)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker 注册成功:', registration.scope);
      })
      .catch((error) => {
        console.error('[PWA] Service Worker 注册失败:', error);
      });
  });
}

app.use(pinia)
app.use(router).use(ElementPlus,{ locale: lang }).mount('#app')
